import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { BsDatepickerConfig, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ErrorResponse } from '../../services/vouchers/error.response';
import { environment } from '../../environments/environment';
import { IVoucherRequest, IVoucherUser, VouchersService } from '../../services/vouchers/vouchers.service';
import { AlertModule } from 'ngx-bootstrap/alert';

@Component({
    selector: 'app-add-voucher-v2',
    templateUrl: './add-voucher-v2.component.html',
  styleUrls: ['./add-voucher-v2.component.css'],
  imports: [FormsModule, AlertModule, BsDatepickerModule]
})
export class AddVoucherV2Component implements OnInit, OnDestroy {
  catagories: string[] = this.getCategories();
  currencies: string[] = this.getCurrencies();
  model = { email_id: "", voucher_code: "", reference: "", voucher_amount: null as (null | number), startdate: "", expiredate: "", category: this.catagories[0], isPromotional: true, currency: this.currencies[0] };
  voucherV2Request: IVoucherRequest;
  voucherUser: IVoucherUser;
  public isSubmit: boolean = false;
  endDatepickerConfig!: Partial<BsDatepickerConfig>;
  startDatepickerConfig!: Partial<BsDatepickerConfig>;
  successAlerts: any[] = [];
  failureAlerts: any[] = [];
  private hasChangePermissions: boolean = false;

  constructor(
    private vouchersService: VouchersService,
    private router: Router) {
    this.voucherV2Request = <IVoucherRequest>{};
    this.voucherUser = <IVoucherUser>{};
    this.configureEndDate();
    this.configureStartDate();
  }

  ngOnInit() {

    if (environment.environmentName == "prod") {
      this.router.navigate(['/page-not-found']);
    }

    this.vouchersService.me().subscribe((data) => {
      this.hasChangePermissions = data.includes("VouchersManager");
      if (this.hasChangePermissions === false)
        this.router.navigate(['/unauthorized']);
    });
  }

  public ngOnDestroy() {
  }

  onSubmit(voucherForm: NgForm) {
    this.isSubmit = true;
    if (this.validateStartDateAndEndDate()) {
      this.setVoucherDetails();
      this.vouchersService.createVoucher(this.voucherV2Request).subscribe(res => {
        this.isSubmit = false;
        voucherForm.resetForm({});
        this.showSuccessMsg();
      }
        , err => {
          if (err.status === 409) {
            this.isSubmit = false;
            voucherForm.resetForm({});
            this.showVoucherExistsMsg();
            console.log(err);
          }
          else {
            this.isSubmit = false;
            voucherForm.resetForm({});

            if (err instanceof ErrorResponse) {
              const errorResponse = err as ErrorResponse;
              if (errorResponse.errors != null) {
                console.log(errorResponse.errors[0].friendlyErrorMessage);
                this.showVoucherErrorMsg(errorResponse.errors[0].friendlyErrorMessage as string);
              }
            } else {
              this.showErrorMsg();
            }
            console.log(err);
          }
        });

    }
    else {
      this.isSubmit = false;
      this.showVoucherErrorMsg(`Voucher start date should not be greater than expiry date!`)
    }
  }

  private showVoucherExistsMsg() {
    this.showVoucherErrorMsg(`The voucher entered already exists. Please enter a new voucher code.`)
  }

  private showErrorMsg() {
    this.showVoucherErrorMsg(`Something went wrong!`)
  }

  private showVoucherErrorMsg(errorMessage: string) {
    this.failureAlerts.push({
      type: 'danger',
      msg: errorMessage,
      timeout: 5000
    });
  }

  private showSuccessMsg() {
    this.successAlerts.push({
      type: 'success',
      msg: `The voucher code has been saved and can be sent to the customer.`,
      timeout: 5000
    });
  }

  private setVoucherDetails() {
    this.voucherV2Request.voucherCode = this.model.voucher_code,
    this.voucherV2Request.reference = this.model.reference,
    this.voucherV2Request.amount = this.model.voucher_amount,
    this.voucherV2Request.currency = this.model.currency,
    this.voucherV2Request.startDate = new Date(this.model.startdate),
    this.voucherV2Request.endDate = new Date(this.model.expiredate),
    this.voucherV2Request.category = this.model.category;
    this.voucherV2Request.isPromotional = this.model.isPromotional === true;

    this.voucherUser.email = this.model.email_id;
    this.voucherV2Request.voucherUsers = new Array();
    this.voucherV2Request.voucherUsers.push(this.voucherUser);
  }

  private validateStartDateAndEndDate() {
    let startDate = new Date(this.model.startdate);
    let endDate = new Date(this.model.expiredate);
    if (startDate > endDate) {
      return false;
    }
    return true;
  }

  private configureEndDate() {
    this.endDatepickerConfig = Object.assign({}, {
      containerClass: 'theme-red',
      dateInputFormat: 'DD-MM-YYYY',
      showWeekNumbers: false,
      minDate: new Date(new Date().setFullYear(new Date().getFullYear() + 2)),
    });
  }

  private configureStartDate() {
    this.startDatepickerConfig = Object.assign({}, {
      containerClass: 'theme-green',
      dateInputFormat: 'DD-MM-YYYY',
      showWeekNumbers: false,
      minDate: new Date()
    });
  }

  private getCategories(): string[] {
    return [
      "Manual villa move",
      "Cooling off period",
      "Self serve villa move",
      "Booking amendment",
      "Customer compensation",
      "Thank you",
      "Staff Discount",
      "Friends and Family Discount",
      "Supplier Discount"
    ];
  }

  private getCurrencies(): string[] {
    return [
      "GBP",
      "EUR",
      "USD"
    ];
  }
}
